















import Vue from "vue";
import { required } from "vuelidate/lib/validators";
import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import ShopifyEditorForm from "../components/ShopifyEditorForm.vue";
import { ShopifyCreateForm } from "../forms/ShopifyCreateForm";
import { Shop } from "../../shop/models/Shop";
import { DeliveryMode } from "../../delivery-modes/models/DeliveryMode";
export default Vue.extend({
  mixins: [permission, dialog],
  components: {
    ShopifyEditorForm
  },
  validations: {
    shopifyCreateForm: {
      shop: { required },
      shopName: { required },
      token: { required },
      hostname: { required },
      mcApiKey: { required },
      mcSecretkey: { required },
      locationId: { required },
      deliveryMode: { required }
    }
  },
  data() {
    const shops: Shop[] = [];
    const deliveryMode: DeliveryMode[] = [];
    const shopifyCreateForm: ShopifyCreateForm = {
      shopName: "",
      token: "",
      hostname: "",
      mcApiKey: "",
      mcSecretkey: "",
      locationId: ""
    };
    return { shopifyCreateForm, shops, deliveryMode };
  },
  async created() {
    await Promise.all([this.getShops()]);
  },
  methods: {
    async getDeliveryModesByShopId(shopId: number) {
      try {
        const {
          data
        } = await (this as any).$dep.deliveryModeUseCase.getDeliveryModesByShopId(
          shopId
        );
        this.deliveryMode = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToShopifyViewPage() {
      this.$router.push({ name: "ShopifyViewPage" });
    },
    async createShopify() {
      try {
        await (this as any).$dep.shopifyUseCase.createShopify(
          this.shopifyCreateForm
        );
        if (
          await (this as any).alertSuccess("Success", "เพิ่ม Shopify สำเร็จ")
        ) {
          this.goToShopifyViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถสร้าง Shopify ได้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to add Shopify",
        "คุณต้องการเพิ่ม Shopify หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.createShopify();
      }
    },
    clear() {
      this.$v.$reset();
      this.shopifyCreateForm = {
        shopName: "",
        token: "",
        hostname: "",
        mcApiKey: "",
        mcSecretkey: "",
        locationId: ""
      };
    }
  }
});
